module.exports = __webpack_public_path__ + "static/media/010.de7bc859.jpg";